import { addButtonValidator } from 'utils/validation';

const defaultValidator = [addButtonValidator('You need to add an address')];

export { defaultValidator };
